import { AppThunkAction } from 'store';
import { UiActions } from './actions';
import { DateFilterType, DateHistoryData } from './interfaces';

export const actionCreators = {
    switchNavBar: (): AppThunkAction<UiActions> => (dispatch) => {
        dispatch({
            type: 'SWITCH_NAV_BAR',
        });
    },
    resetFinanceDateFilters: (): AppThunkAction<UiActions> => (dispatch) => {
        dispatch({
            type: 'RESET_FINANCE_DATE_FILTERS',
        });
    },
    setFinanceDateFilters: (dateFilter: DateFilterType, dateHistory: DateHistoryData[], from: Date | null, to: Date | null): AppThunkAction<UiActions> => (dispatch) => {
        dispatch({
            type: 'SET_FINANCE_DATE_FILTERS',
            payload: {
                dateFrom: from,
                dateTo: to,
                dateFilter,
                dateHistory,
            }
        });
    },
    setFinanceDateFilter: (dateFilter: DateFilterType): AppThunkAction<UiActions> => (dispatch) => {
        dispatch({
            type: 'SET_FINANCE_DATE_FILTER',
            payload: dateFilter,
        });
    },
    setFinanceDateHistory: (dateHistory: DateHistoryData[]): AppThunkAction<UiActions> => (dispatch) => {
        dispatch({
            type: 'SET_FINANCE_DATE_HISTORY',
            payload: dateHistory,
        });
    },
    setFinanceDateRange: (from: Date | null, to: Date | null): AppThunkAction<UiActions> => (dispatch) => {
        dispatch({
            type: 'SET_FINANCE_DATE_RANGE',
            payload: { from, to },
        });
    },
};
